export default __webpack_public_path__ + "static/screen_1_09-dd8718fd19b180634be7c05f2d36ed95.svg";